import styled from 'styled-components';

import { Divider } from 'components';

export const HorizontalDivider = styled(Divider)`
  border-bottom-color: ${props => props.theme.custom.palette.muted200};
  border-bottom-width: 1px;
  border-bottom-style: solid;
`;
